export const CURRENT_PROFILE_KEY_BASE = 'current_profile';
export const CurrentProfileKeyFactory = {
    exact: () => [CURRENT_PROFILE_KEY_BASE],
};
